import React from 'react';
import { Accordion } from 'react-bootstrap';
import Link from "../../buttons/Link";

export default function AccordionItemAbout() {
    return (
        <Accordion.Item eventKey={1}>
            <Accordion.Header>About this app</Accordion.Header>
            <Accordion.Body>
                <p>
                    Generates passwords by using a <Link href="https://en.wikipedia.org/wiki/Pseudorandom_number_generator">pseudorandom number generator</Link> to pull characters (numbers, symbols, upper and lower case letters) from a character <Link href="https://en.wikipedia.org/wiki/Matrix_(mathematics)">matrix</Link> and concatenating them into a single string.
                </p>

                <p>
                    Developed by <Link href="https://github.com/AtylaDaSilva">Atyla da Silva</Link>. This is my first app, now remade in <Link href="https://react.dev/">React</Link>.
                </p>

                <p>
                    <strong>None</strong> of the passwords generated by this app are stored in any way or sent to the developer or any third parties.
                </p>

                <p>
                    This app was made possible with:
                </p>

                <ul>
                    <li>
                        <Link href="https://github.com/facebook/create-react-app">Create React App</Link>
                    </li>
                    <li>
                        <Link href="https://github.com/facebook/react/releases">React 18.2.0</Link>
                    </li>
                    <li>
                        <Link href="https://github.com/twbs/bootstrap">Bootstrap 5.3.2</Link>
                    </li>
                    <li>
                        <Link href="https://react-bootstrap.github.io/">React-Bootstrap 2.10.1</Link>
                    </li>
                    <li>
                        <Link href="https://github.com/twbs/icons">Bootstrap Icons 1.11.2</Link>
                    </li>
                    <li>
                        <Link href="https://github.com/dropbox/zxcvbn">Zxcvbn 4.4.2</Link>
                    </li>
                    <li>
                        <Link href="https://github.com/ai/nanoid">Nanoid 5.0.6</Link>
                    </li>
                    <li>
                        <Link href="https://www.flaticon.com">FlatIcon</Link> - Favicon original art by <Link href="https://www.flaticon.com/authors/pbig">pbig</Link>
                    </li>
                </ul>

            </Accordion.Body>
        </Accordion.Item>
    );
}